module.exports = __webpack_public_path__ + "media/images/emblems/Campo(Vallemaggia)-coat_of_arms-d585c90d0f69dd40c5ea95a5b9416094.svg";